import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!email) return;

    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setIsLoading(false);
      setEmail('');
    }, 1500);
  };

  const benefits = [
    {
      icon: 'Zap',
      title: 'Weekly Guide Updates',
      description: 'New buying guides and expert insights delivered every Tuesday'
    },
    {
      icon: 'Tag',
      title: 'Exclusive Deal Alerts',
      description: 'Be first to know about price drops and limited-time offers'
    },
    {
      icon: 'Award',
      title: 'Expert Recommendations',
      description: 'Personalized vacuum suggestions based on your preferences'
    },
    {
      icon: 'BookOpen',
      title: 'Seasonal Buying Guides',
      description: 'Timely guides for spring cleaning, holidays, and more'
    }
  ];

  if (isSubscribed) {
    return (
      <section className="py-16 bg-gradient-to-br from-success/10 to-success/5">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-2xl shadow-floating p-8">
            <div className="w-16 h-16 bg-success rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="CheckCircle" size={32} className="text-white" />
            </div>
            <h2 className="text-2xl font-bold text-text-primary mb-4">
              Welcome to Vacuum Guide Insider!
            </h2>
            <p className="text-lg text-text-secondary mb-6">
              You're all set! Check your email for a welcome message and your first exclusive buying guide.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="default"
                iconName="BookOpen"
                iconPosition="left"
              >
                Browse Guides
              </Button>
              <Button
                variant="outline"
                iconName="Settings"
                iconPosition="left"
              >
                Manage Preferences
              </Button>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-floating overflow-hidden">
          <div className="lg:flex">
            <div className="lg:w-1/2 p-8 lg:p-12">
              <div className="inline-flex items-center px-4 py-2 bg-primary/10 rounded-full text-primary text-sm font-medium mb-6">
                <Icon name="Mail" size={16} className="mr-2" />
                Vacuum Guide Insider
              </div>
              
              <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
                Never Miss a
                <span className="block text-primary">Smart Purchase</span>
              </h2>
              <p className="text-lg text-text-secondary mb-8">
                Join 25,000+ smart shoppers who get our expert buying guides, exclusive deals, and personalized recommendations delivered weekly.
              </p>
              
              <form onSubmit={handleSubmit} className="space-y-4 mb-8">
                <Input
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e?.target?.value)}
                  required
                  className="text-lg"
                />
                <Button
                  type="submit"
                  variant="default"
                  size="lg"
                  loading={isLoading}
                  iconName="ArrowRight"
                  iconPosition="right"
                  fullWidth
                  disabled={!email}
                >
                  Get Free Buying Guides
                </Button>
              </form>
              
              <div className="flex items-center text-sm text-text-secondary">
                <Icon name="Shield" size={16} className="mr-2 text-success" />
                <span>No spam, unsubscribe anytime. We respect your privacy.</span>
              </div>
            </div>
            
            <div className="lg:w-1/2 bg-muted/30 p-8 lg:p-12">
              <h3 className="text-xl font-semibold text-text-primary mb-6">
                What You'll Get:
              </h3>
              
              <div className="space-y-6">
                {benefits?.map((benefit, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="bg-primary/10 p-2 rounded-lg flex-shrink-0">
                      <Icon name={benefit?.icon} size={20} className="text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-text-primary mb-1">
                        {benefit?.title}
                      </h4>
                      <p className="text-sm text-text-secondary">
                        {benefit?.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="mt-8 p-4 bg-accent/10 rounded-lg">
                <div className="flex items-center space-x-3">
                  <Icon name="Gift" size={24} className="text-accent" />
                  <div>
                    <h4 className="font-semibold text-text-primary">Bonus Welcome Gift</h4>
                    <p className="text-sm text-text-secondary">
                      Free "Ultimate Vacuum Buying Checklist" PDF (valued at $19)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSignup;